import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconIndicatorSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <rect width="10" height="2" x="3" y="7" fill="currentColor" rx="1" />
    </BaseIcon>
  );
}
